
import { defineComponent } from 'vue';
import { Empty } from 'ant-design-vue';

const component = defineComponent({
  name: '',
  components: {
    aEmpty: Empty,
  },
  setup() {
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    return { simpleImage };
  },
});

export default component;
